<script>
  import { onMount } from 'svelte'
  import { isValidEmail, checkPassword } from '../helpers/form-validation.js'
  import AuthContainer from './AuthContainer.svelte'
  import { push, link, querystring, replace } from 'svelte-spa-router'
  import TextInput from '../components/TextInput.svelte'
  import Button from '../components/Button.svelte'
  import Modal from '../components/Modal.svelte'
  import Privacy from '../components/Privacy.svelte'
  import Terms from '../components/Terms.svelte'
  import { snackBarStore, modalStore } from '../state/store'
  import { request } from '../helpers/api'
  import { t } from '../i18n/i18n'

  let name = ''
  let email = ''
  let phone = ''
  let password = ''
  let confirmPassword = ''
  onMount(() => {
    let params = new URLSearchParams($querystring)
    let urlEmail = params.get('email')
    email = urlEmail ? atob(urlEmail) : ''
  })

  $: passwordValid = checkPassword(password)
  $: emailValid = isValidEmail(email)
  $: formValid = passwordValid && emailValid && password === confirmPassword

  const getInvitation = async (id, email) => {
    const response = await fetch(`/api/invite?id=${id}&email=${email}`, {
      method: 'GET',
    })
    if (!response.ok) {
      throw new Error(response.statusText)
    }
    const invitationResponse = response.json()
    return invitationResponse
  }

  const addToGroup = async user => { 
    try {
      return await fetch(`/api/users`, {
        method: 'POST',
        body: JSON.stringify(user)
      })
    } catch(e) {
      throw new Error($t.something_wrong)
    }
  }

  const removeInvite = async (email, tenant) => {
    try {
      const response = await request({
        url: `/api/invite`,
        method: 'DELETE',
        body: JSON.stringify({
          email,
          tenant,
        })
      })
    } catch (error) {
      snackBarStore.set({ message: $t.something_wrong, type: 'error' })
    }
  }

  const submitForm = async () => {
    let params = new URLSearchParams($querystring)
    let tenant_id = params.get('tenant')
    let newUser = {}
    if (tenant_id) {
      try {
        const invitation = await getInvitation(tenant_id, email)
        if (invitation) {
          newUser = {
            name,
            phone,
            email,
            password,
            tenant_id: atob(tenant_id),
            role: invitation.role
          }
        } else {
          throw new Error('User has not been invited')
        }
      } catch (error) {
        snackBarStore.set({ message: $t.something_wrong, type: 'error' })
      }
    }

    try {
      await addToGroup(newUser)
      await removeInvite(newUser.email, newUser.tenant_id)
      replace('/sign-in/')
    } catch (error) {
      snackBarStore.set({ message: $t.something_wrong, type: 'error' })
    }
  }

</script>

<style>
  form {
    margin-bottom: 2rem;
  }
  p:first-child {
    margin-top: 2rem;
  }

</style>

<AuthContainer>
  <h1>{$t['Sign up']}</h1>
  <form on:submit|preventDefault={submitForm}>
    <div>
      <p>{$t['Login email']}</p>
      <p>{email}</p>
    </div>
    <TextInput
      id='name'
      label='{$t.full_name}'
      validityMessage='{$t['Please enter a contact name']}'
      on:input={event => (name = event.target.value)}
      value="{name}" />
    <TextInput
      id='phone'
      label='{$t['phone']}'
      validityMessage='{$t['Please enter a phone number']}'
      on:input={event => (phone = event.target.value)}
      value="{phone}" />
    <TextInput
      id='password'
      label='{$t.password}'
      type='password'
      valid={passwordValid}
      toggleVisible=true
      validityMessage='{$t.valid_password_message}'
      staticMessage='{$t.password_rules}'
      value={password}
      on:input={event => (password = event.target.value)} />
    <TextInput
      id='confirmPassword'
      label='{$t['Confirm password']}'
      type='password'
      valid={password && password === confirmPassword}
      toggleVisible=true
      validityMessage='{$t.password_match}'
      value={confirmPassword}
      on:input={event => (confirmPassword = event.target.value)} />
    <Button type='submit' size='full' disabled={!formValid}>
      {$t['Sign up']}
    </Button>
  </form>
  <p class='g-center'>{$t.register_agree} <button on:click={() => modalStore.toggle('terms')} class='g-unbutton'>{$t.terms_conditions_and_privacy}</button></p>
  <Modal name='terms' large='true'>
    <h2 slot='header'>{$t.terms_conditions_privacy}</h2>
    <section>
      <Privacy></Privacy>
      <Terms></Terms>
    </section>
  </Modal>
</AuthContainer>
